import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import AgreementsTable from './AgreementsTable';
import AvailabilityContractsTable from './AvailabilityAgreementsTable';
import { ContFilterYear, H5Styled } from '../../../styled-components';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import { useAuth } from '../../../commons/Auth';
import ExternalCondoAgreementsTable from './ExternalCondoAgreementsTable';
import ExternalAdminAgreementsTable from './ExternalAdminAgreementsTable';
import EnergyContractsTable from './EnergyContractsTable';

const CondoAgreementsPresentational = ({
  data,
  availabilityAgreements,
  externalAgreements,
  externalAvailabilityAgreements,
  energyContracts,
  total,
  profile,
  handleFileListView,
  fetchAgreements,
  fetchAvailabilityAgreements,
  assemblyActived,
  handleFileListViewExternal,
  handleFileListViewEnergyContract,
  onFilter,
  query,
}) => {
  const [t] = useTranslation('CONDO_AGREEMENTS');
  const [{ newIsAdmin = false } = {}] = useAuth();

  return (
    <>
      <section style={{ marginTop: '10px' }}>
        <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
          <Col sm="12" md="6" lg="3" className="select-wrapper">
            <ContFilterYear className="no-width" style={{ marginBottom: '0' }}>
              <Row>
                <Col xs="6">
                  <Label>{t('COMMON:TITLE_FILTER_SIGNIN_YEAR')}</Label>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <CustomInput
                      type="select"
                      id="selectYear"
                      name="year"
                      value={query.year}
                      onChange={({ target: { value: year } }) => {
                        onFilter({ year });
                      }}
                    >
                      {generateYearOptions()}
                    </CustomInput>
                  </FormGroup>
                </Col>
              </Row>
            </ContFilterYear>
          </Col>
        </Row>
      </section>

      <section style={{ marginTop: '10px' }}>
        <Row
          xs={8}
          className="align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <Col>
            <H5Styled>{t('AGREEMENTS:SUPPLIER_CONDO')}</H5Styled>
          </Col>
        </Row>

        <AgreementsTable
          data={data}
          total={total}
          profile={profile}
          assemblyActived={assemblyActived}
          handleFileListView={handleFileListView}
          fetchAgreements={fetchAgreements}
        />
      </section>

      <section style={{ marginTop: '10px' }}>
        <Row
          xs={8}
          className="align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <Col>
            <H5Styled>{t('AGREEMENTS:SUPPLIER_ADMIN')}</H5Styled>
          </Col>
        </Row>

        <AvailabilityContractsTable
          data={availabilityAgreements}
          total={total}
          profile={profile}
          assemblyActived={assemblyActived}
          handleFileListView={handleFileListView}
          fetchAvailabilityAgreements={fetchAvailabilityAgreements}
        />
      </section>

      <section style={{ marginTop: '10px' }}>
        <Row
          xs={8}
          className="align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <Col>
            <H5Styled>{t('AGREEMENTS:SUPPLIER_CONDO_EXTERNAL')}</H5Styled>
          </Col>
        </Row>

        <ExternalCondoAgreementsTable
          data={externalAgreements}
          total={total}
          profile={profile}
          handleFileListViewExternal={handleFileListViewExternal}
        />
      </section>

      <section style={{ marginTop: '10px' }}>
        <Row
          xs={8}
          className="align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <Col>
            <H5Styled>{t('AGREEMENTS:SUPPLIER_ADMIN_EXTERNAL')}</H5Styled>
          </Col>
        </Row>

        <ExternalAdminAgreementsTable
          data={externalAvailabilityAgreements}
          total={total}
          profile={profile}
          handleFileListViewExternal={handleFileListViewExternal}
        />
      </section>

      <section style={{ marginTop: '10px' }}>
        <Row
          xs={8}
          className="align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <Col>
            <H5Styled>{t('AGREEMENTS:ENERGY_CONTRACTS')}</H5Styled>
          </Col>
        </Row>

        <EnergyContractsTable
          data={energyContracts}
          total={total}
          handleFileListViewEnergyContract={handleFileListViewEnergyContract}
        />
      </section>
    </>
  );
};

export default CondoAgreementsPresentational;
